import React, { PropTypes, PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';

import Text from '@dbk/ui-text';

class Marque extends PureComponent {
  render() {
    const { marque : {marqueData}, i18n: {messages} }= this.props;
    return(
      <div className="marqueeContent">
        <div className="justifyText">
          <Text secondary>
            {marqueData.configKeyValue}
          </Text>
        </div>
      </div>
    );
  }
}

Marque.propTypes = {
};

export default createContainer({
  $queries: {
    marque:{
      marqueData: true,
    },
    i18n: {
      messages: true,
    }
  },
})(Marque);
